import styles from '../styles/SearchButton.module.css'

export default function SearchButton(props){
  return (
    <div
      className={props.activated ? [styles.activated, styles.button].join(' ') : styles.button}
      onClick={props.clicked ? props.clicked : null}
    >Search</div>
  )
}
